<template lang="pug">
  div(:class="b()")
    adviser-avatar(:class="b('avatar')" :image="avatar")
    div(:class="b('bubble')")
      beat-loader(size="12px")
</template>

<script>
  import AdviserAvatar from './adviser-avatar';
  import BeatLoader from 'vue-spinner/src/BeatLoader.vue';

  export default {
    name: 'adviser-writing',

    props: {
      avatar: { type: String, required: true },
    },

    components: { AdviserAvatar, BeatLoader },
  };
</script>

<style lang="sass" scoped>
  @import '~@/sass/mixins'

  .adviser-writing
    display: flex
    align-items: center
    margin: 1rem 1rem

    +tablet
      margin: 1rem 0 0 0

    &__avatar
      width: 55px
      height: 55px
      margin-right: 18px
      flex-shrink: 0

      +tablet
        width: 79px
        height: 79px
        margin-right: 20px

    &__bubble
      $backgroundColor: darken(white, 6%)

      position: relative
      background-color: $backgroundColor
      border-radius: 4px
      padding: .5rem 1rem .3rem 1rem

      &:after
        $size: 10px
        content: ''

        position: absolute
        left: 0
        top: 0
        width: 0
        height: 0
        transform: translateX(-100%) translateY(50%)

        border-top: $size solid transparent
        border-right: $size * 1 solid $backgroundColor
        border-bottom: $size solid transparent

</style>